import * as actionsTypes from "./actionTypes";

const getData = value => ({
    type: actionsTypes.GET_DATA_REQUEST,
    value: value
});

const search = value => ({
    type: actionsTypes.SEARCH_REQUEST,
    value: value
});

const searchUsers = searchFields => ({
    type: actionsTypes.USER_SEARCH_REQUEST,
    searchFields
});

const getUserData = (userId, fetchRoleAndEntityInfo = false) => ({
    type: actionsTypes.GET_USER_REQUEST,
    userId,
    fetchRoleAndEntityInfo
});

const createUser = userData => ({
    type: actionsTypes.CREATE_USER_REQUEST,
    userData
});

const editUser = (userId, userData, loggedInUser) => ({
    type: actionsTypes.EDIT_USER_REQUEST,
    userId,
    userData,
    loggedInUser
});

const deleteUser = userId => ({
    type: actionsTypes.DELETE_USER_REQUEST,
    userId
});

const resetUserForm = () => ({
    type: actionsTypes.RESET_USER_FORM
});

export default {
    getData,
    search,
    searchUsers,
    getUserData,
    createUser,
    editUser,
    deleteUser,
    resetUserForm
}